import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { FaHome, FaDatabase, FaEnvelope, FaSignOutAlt } from "react-icons/fa";

const LOGO_URL = "https://benton.lightideaproductions.co.uk/logo.png";

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const isDashboardActive =
    location.pathname === "/" || location.pathname === "/admin";

  const isStaffDatabaseActive = location.pathname === "/staff-db";
  const isSendOffActive = location.pathname === "/send-off";
  const isFormDBActive = location.pathname === "/send-off";

  const navLinkClasses = (isActive) =>
    `inline-flex items-center gap-2 rounded-2xl border px-4 py-2 text-sm font-medium transition ${
      isActive
        ? "border-cyan-300/40 bg-cyan-400/10 text-cyan-100"
        : "border-white/10 bg-white/[0.05] text-white/85 hover:bg-white/[0.08]"
    }`;

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[rgba(8,17,31,0.78)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1800px] items-center justify-between gap-4 px-3 py-4 sm:px-4 lg:px-6">
        <div className="min-w-0">
          <div className="flex items-center gap-4">
            <img
              src={LOGO_URL}
              alt="Benton Theatres Logo"
              className="h-16 w-16 object-contain sm:h-20 sm:w-20"
            />
            <div className="min-w-0">
              <div className="truncate text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                Benton Theatres
              </div>
              <div className="text-sm uppercase tracking-[0.22em] text-white/45 sm:text-base">
                Admin Dashboard
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <nav className="flex items-center gap-2 sm:gap-3">
            <Link to="/admin" className={navLinkClasses(isDashboardActive)}>
              <span className="text-xs">
                <FaHome />
              </span>
              <span>Dashboard</span>
            </Link>

            <Link
              to="/staff-db"
              className={navLinkClasses(isStaffDatabaseActive)}
            >
              <span className="text-xs">
                <FaDatabase />
              </span>
              <span>Staff Database</span>
            </Link>

            <Link to="/send-off" className={navLinkClasses(isSendOffActive)}>
              <span className="text-xs">
                <FaEnvelope />
              </span>
              <span>Email</span>
            </Link>

            <Link to="/form-db" className={navLinkClasses(isFormDBActive)}>
              <span className="text-xs">
                <FaEnvelope />
              </span>
              <span>Form Responses</span>
            </Link>
          </nav>

          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center gap-2 rounded-2xl border border-red-400/20 bg-red-500/10 px-4 py-2 text-sm font-medium text-red-100 transition hover:bg-red-500/20"
          >
            <span className="text-xs">
              <FaSignOutAlt />
            </span>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}